var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInnovation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 73,
    viewBox: "0 0 54 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8401 22.6254L34.2105 40.3359L53.3401 41.8674L38.7665 54.3427L43.218 73L26.8401 63.0031L10.4622 73L14.9137 54.3427L0.340088 41.8674L19.4697 40.3359L26.8401 22.6254ZM26.8401 40.7501L24.266 46.9355L17.5923 47.4681L22.6777 51.8226L21.1207 58.3353L26.8401 54.844L32.556 58.3353L31.0025 51.8261L36.0844 47.4681L29.4142 46.9355L26.8401 40.7501ZM12.9074 0V31.3275H5.94103V0H12.9074ZM47.7391 0V31.3275H40.7728V0H47.7391ZM30.3233 0V17.4042H23.3569V0H30.3233Z",
    fill: "#030762"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.9b79d17a0ffb2cfae21b8716f4a6b379.svg";
export { ForwardRef as ReactComponent };